import * as React from 'react';

import { Card, MarkdownLite, Stack, Text } from '@origin-digital/ods-core';

import * as content from './content.json';

export const MyAccountCard: React.SFC = () => (
  <Card data-id="my-account-card">
    <Stack space={['large', 'xlarge']}>
      {content.body.map((text, idx) => (
        <Text key={idx}>
          <MarkdownLite>{text}</MarkdownLite>
        </Text>
      ))}
    </Stack>
  </Card>
);
